import {Vue, Component} from 'vue-property-decorator';
import { Observer } from "mobx-vue";
import Navigation from '@/components/Navigation';

import OrderDetails from '@/components/OrderDetails';
import PayType from '@/components/PayType'
import HeadlineButton from '@/components/Button/HeadlineButton';
import Log from '@/components/Log';

import GlobalStore from '@/store/GlobalStore';
import PackageStore from '@/store/PackageStore';
import HomeStore from '@/store/HomeStore';

@Observer
@Component
export default class ConfirmOrder extends Vue {

  constructor(props: any) {
    super(props)
  }

  state = {
    GlobalStore,
    PackageStore,
    HomeStore
  }

  async mounted () {
    if (this.$route.query.id) {
      this.state.PackageStore.setUserItemId(this.$route.query.id)
    }
  }
  // 缓存数据
  render() {
    return (
      <div class='card' style="background: #FAFAFA; height: 93vh">
        <Navigation title='确认订单' />
        <OrderDetails data={this.state.PackageStore.activeData} number={this.state.HomeStore.saleCardInfo.number + this.state.HomeStore.couponInfo.number} />
        <PayType/>
        <Log number='N1050'>
          <HeadlineButton click={() => this.state.PackageStore.cloudDevice(false)}>确认购买</HeadlineButton>
        </Log>
        <Log type='hooks' number='N1000'/>
      </div>
    )
  }

}
